import captainFinance from "./captainFinance.component";
import captainFinanceUrls from "./captainFinance.urls";
import CaptainFinanceTransforms from "./captainFinance.transforms";

const captainFinanceModule = angular
  .module("app.components.captainFinance", [])
  .component("captainFinancePage", captainFinance)
  .service("CaptainFinanceTransforms", CaptainFinanceTransforms)
  .config(captainFinanceUrls);

export default captainFinanceModule;



// WEBPACK FOOTER //
// ./src/pages/captainFinance/captainFinance.module.js